import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';
import { StatusTag } from '@innovyze/stylovyze';

export const StatusTagCell = (
	value: string,
	excluded: boolean,
	width: string,
) => {
	const { t } = useGlobalization();

	if (value !== '--') {
		if (excluded)
			return (
				<StatusTag text={t('Excluded')} color="neutral" width={width} />
			);
		else
			return (
				<StatusTag
					text={t('Included')}
					color="positive"
					width={width}
				/>
			);
	}

	return '';
};
